import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pool-arena/artifacts/mmmf5ngg_logo%20%C3%A1o.jpg";

/**
 * Icon: "ĐT" rendered with gold gradient on dark — visually consistent with the brand
 * without depending on the cropped raster image (which has multiple variants in one file).
 */
export const LogoIcon = ({ size = 40, className = "" }) => {
  const fontSize = Math.round(size * 0.42);
  return (
    <span
      className={`inline-grid place-items-center rounded-lg shrink-0 relative overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        background: "linear-gradient(135deg, #0a0a0e 0%, #1a1208 100%)",
        border: "1px solid rgba(252, 211, 77, 0.4)",
        boxShadow: "inset 0 0 12px rgba(252, 211, 77, 0.15)",
      }}
      aria-label="Đấu Trường Billiards"
    >
      <span
        className="font-display font-black tracking-tighter relative"
        style={{
          fontSize,
          background: "linear-gradient(135deg, #fde68a 0%, #f59e0b 45%, #b45309 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          textShadow: "0 1px 0 rgba(0,0,0,0.4)",
          letterSpacing: "-0.04em",
        }}
      >
        ĐT
      </span>
      {/* subtle shine */}
      <span
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 40%)",
        }}
      />
    </span>
  );
};

/**
 * Horizontal: icon + "ĐẤU TRƯỜNG / BILLIARDS" in gold
 */
export const LogoHorizontal = ({ size = 40, className = "", subClassName = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <LogoIcon size={size} />
    <div className={`leading-tight ${subClassName}`}>
      <div
        className="font-display font-black text-sm"
        style={{
          background: "linear-gradient(135deg, #fde68a 0%, #f59e0b 60%, #b45309 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          letterSpacing: "0.02em",
        }}
      >
        ĐẤU TRƯỜNG
      </div>
      <div className="text-[10px] tracking-[0.3em] -mt-0.5 font-display font-semibold text-amber-400/90">
        BILLIARDS
      </div>
    </div>
  </div>
);

/**
 * Hero: shows the actual uploaded brand image as a banner (top section of the file)
 */
export const LogoHero = ({ className = "", height = 220 }) => (
  <div
    className={`relative w-full rounded-2xl overflow-hidden border border-amber-500/25 ${className}`}
    style={{
      height,
      backgroundImage: `url("${LOGO_URL}")`,
      backgroundSize: "auto 200%",
      backgroundPosition: "center 0%",
      backgroundRepeat: "no-repeat",
    }}
    aria-label="Đấu Trường Billiards"
  />
);

export default LogoIcon;
